export default __webpack_public_path__ + "static/media/placeholder-image-cover.646c8eba.svg";